import { type SelectDataObject } from '../_tools/inputfields/Select';
import AhdCarsLogo from '../svg/logos/portale/AhdCars';
import AhdScanLogo from '../svg/logos/portale/AhdScan';
import AllesAutoLogo from '../svg/logos/portale/AllesAuto';
import AutoUncleLogo from '../svg/logos/portale/AutoUncle';
import Autoscout24Logo from '../svg/logos/portale/Autoscout24';
import CX9Logo from '../svg/logos/portale/CX9Logo';
import CarGurusLogo from '../svg/logos/portale/CarGurus';
import Digital35Logo from '../svg/logos/portale/Digital35';
import EviumLogo from '../svg/logos/portale/EviumLogo';
import HeyCarLogo from '../svg/logos/portale/HeyCar';
import LeasingMarktLogo from '../svg/logos/portale/LeasingMarkt';
import LocarlLogo from '../svg/logos/portale/Locarl';
import MobileDeLogo from '../svg/logos/portale/MobileDe';
import SantanderLogo from '../svg/logos/portale/Santander';
import VWFinancialServices from '../svg/logos/portale/VWFinancialServices';
import Web1On1Logo from '../svg/logos/portale/Web1On1';
import Webkommunikation24Logo from '../svg/logos/portale/Webkommunikation24';

export type Portal = Pick<SelectDataObject, 'et' | 'group' | 'hidden' | 'icon' | 'iconAutoSizeHeight' | 't' | 'warningSPT'> & {
    i: number;
    parent?: number;
    color?: string;
};

const sPortalId: Portal[] = [
    { i: 0, t: '(unbekannt)' },
    { i: 1, hidden: true, t: 'mobile.de', icon: MobileDeLogo, iconAutoSizeHeight: '1em', color: '#f60', group: 'mobile.de', parent: 1, et: '1. Zugang' },
    { i: 2, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '1. Zugang' },
    { i: 4, t: 'webmobile24', group: 'webmobile24', parent: 4, et: '1. Zugang' },
    { i: 5, t: 'AOL' },
    { i: 6, t: 'lycos' },
    { i: 7, t: 'Allianz Autowelt' },
    { i: 8, t: 'GeWaTo', color: '#db002a', group: 'GeWaTo', parent: 8, et: '1. Zugang' },
    { i: 10, t: 'T-Online' },
    { i: 11, t: 'webauto.de', group: 'webmobile24', parent: 11, et: '1. Zugang' },
    { i: 12, t: 'DAZ24' },
    { i: 15, t: 'autoanzeigen.de' },
    { i: 17, t: 'VW', color: '#6e9dcc' },
    { i: 18, t: 'Homepages' },
    { i: 19, t: 'ADAC' },
    { i: 20, t: 'Freenet' },
    { i: 34, t: 'automobile.de', group: 'automobile.de', parent: 34, et: '1. Zugang' },
    { i: 36, t: '1A-Automarkt.de' },
    { i: 37, t: 'auto24.de' },
    { i: 38, t: 'gebrauchtwagen.de', group: 'gebrauchtwagen.de', parent: 38, et: '1. Zugang' },
    { i: 39, t: 'dresdner-automarkt.de' },
    { i: 41, t: 'caraworld.de' },
    { i: 46, t: 'autobild.de' },
    { i: 48, t: 'auto.de' },
    { i: 50, t: 'autoboersen-regional.de' },
    { i: 51, t: 'auto-m' },
    { i: 52, t: 'dhd24' },
    { i: 70, t: 'samochody.pl' },
    { i: 76, t: 'auto-online.ch' },
    { i: 79, t: 'autohaus-spranger.de' },
    { i: 80, t: 'tipcars.com' },
    { i: 82, t: 'automarkt-mainfranken.de' },
    { i: 83, t: 'tauwald.de' },
    { i: 84, t: 'click4car.de' },
    { i: 85, t: 'vw-rudolph.com' },
    { i: 86, t: 'hymer.com' },
    { i: 87, t: 'skoda-auto.de', group: 'skoda-auto.de', parent: 87, et: '1. Zugang' },
    { i: 88, t: 'Audi separat' },
    { i: 89, t: 'VW separat' },
    { i: 94, t: 'Deltakonzept', group: 'Deltakonzept', parent: 94, et: '1. Zugang' },
    { i: 96, t: 'Passauer Neue Presse' },
    { i: 99, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '2. Zugang' },
    { i: 100, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '3. Zugang' },
    { i: 101, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '4. Zugang' },
    { i: 102, t: 'Modix', group: 'Modix', parent: 102, et: '1. Zugang' },
    { i: 103, t: 'carstart.de' },
    { i: 106, t: '1000ps' },
    { i: 108, t: 'Importautos.nl' },
    { i: 110, t: 'Motoso', group: 'Motoso', parent: 102, et: '1. Zugang' },
    { i: 112, t: 'DAT (lokale Einstellung)', group: 'DAT', et: '(lokal)' },
    { i: 114, t: 'Westfaelische Nachrichten' },
    { i: 115, t: 'gwliste.de' },
    { i: 116, t: 'gebrauchtwagenlocator.de' },
    { i: 117, t: 'aricars.eu' },
    { i: 118, t: 'TruckScout 24' },
    { i: 120, t: 'autohaus-ruedersdorf.de' },
    { i: 121, t: 'PKW.DE (ab 01.09.2009)', group: 'PKW.DE', parent: 121, et: '1. Zugang' },
    { i: 122, t: 'Carzilla' },
    { i: 123, t: 'Luxauto.lu' },
    { i: 124, t: 'Augsburger Allgemeine' },
    { i: 125, t: 'Pixelkonzept' },
    { i: 126, t: 'kuhn-witte.de' },
    { i: 128, t: 'AOS' },
    { i: 130, t: 'volksstimme.de', group: 'volksstimme.de', parent: 130, et: '1. Zugang' },
    { i: 131, t: 'carfinanz24.net' },
    { i: 132, t: 'kalaydo.de' },
    { i: 133, t: 'autrado.de' },
    { i: 134, t: 'GeWaTo', color: '#db002a', group: 'GeWaTo', parent: 8, et: '2. Zugang' },
    { i: 135, t: 'ace-gebrauchtwagen.de' },
    { i: 136, t: 'Homepage AH Knott' },
    { i: 138, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '5. Zugang' },
    { i: 139, t: 'GeWaTo', color: '#db002a', group: 'GeWaTo', parent: 8, et: '3. Zugang' },
    { i: 141, t: 'webmobile24', group: 'webmobile24', parent: 4, et: '2. Zugang' },
    { i: 142, t: 'Homepage AH Perski' },
    { i: 143, t: 'Badische-Zeitung Online' },
    { i: 145, t: 'gebrauchtwagen.de', group: 'gebrauchtwagen.de', parent: 38, et: '2. Zugang' },
    { i: 146, t: 'Alternative Motion' },
    { i: 147, t: 'Such & Find' },
    { i: 148, t: 'Opel' },
    { i: 149, t: 'Kappe' },
    { i: 150, t: 'autohaus-ostmann.de' },
    { i: 151, t: 'Homepage quality-cars' },
    { i: 152, t: 'Homepage vierreifeneineliebe.de ' },
    { i: 154, t: 'x-leasing.de' },
    { i: 156, t: 'skoda-auto.de', group: 'skoda-auto.de', parent: 87, et: '2. Zugang' },
    { i: 157, t: 'skoda-auto.de', group: 'skoda-auto.de', parent: 87, et: '3. Zugang' },
    { i: 158, t: 'Motoso', group: 'Motoso', parent: 102, et: '2. Zugang' },
    { i: 159, t: 'Motoso', group: 'Motoso', parent: 102, et: '3. Zugang' },
    { i: 160, t: 'Motoso', group: 'Motoso', parent: 102, et: '4. Zugang' },
    { i: 161, t: 'Motoso', group: 'Motoso', parent: 102, et: '5. Zugang' },
    { i: 163, t: 'e.Modix' },
    { i: 164, t: 'autohausen.de', group: 'autohausen.de', parent: 164, et: '1. Zugang' },
    { i: 165, t: 'autohaus-reick.de' },
    { i: 166, t: 'autos-weber.de' },
    { i: 167, t: 'mobicar.de' },
    { i: 168, t: 'Homepage Lueg' },
    { i: 169, t: 'DAT online', group: 'DAT', et: '(online)' },
    { i: 171, t: 'twitter' },
    { i: 172, t: 'twitter account' },
    { i: 173, t: 'seat-zander.de' },
    { i: 174, t: 'bv-software.de' },
    { i: 176, t: 'facebook', group: 'facebook', parent: 176, et: '1. Zugang' },
    { i: 177, t: 'webleasing.ro' },
    { i: 178, t: 'r-quadrat' },
    { i: 180, t: 'Auktion und Markt' },
    { i: 181, t: 'facebook', group: 'facebook', parent: 176, et: '2. Zugang' },
    { i: 182, t: 'volksstimme.de', group: 'volksstimme.de', parent: 130, et: '2. Zugang' },
    { i: 183, t: 'volksstimme.de', group: 'volksstimme.de', parent: 130, et: '3. Zugang' },
    { i: 184, t: 'volksstimme.de', group: 'volksstimme.de', parent: 130, et: '4. Zugang' },
    { i: 185, t: 'volksstimme.de', group: 'volksstimme.de', parent: 130, et: '5. Zugang' },
    { i: 187, t: 'Renaultbörse' },
    { i: 190, t: 'webauto.de', group: 'webmobile24', parent: 11, et: '2. Zugang' },
    { i: 191, t: 'Schwacke online' },
    { i: 192, t: 'autodo' },
    { i: 193, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '6. Zugang' },
    { i: 194, t: 'GeWaTo', color: '#db002a', group: 'GeWaTo', parent: 8, et: '4. Zugang' },
    { i: 195, t: 'gebrauchtwagen.de', group: 'gebrauchtwagen.de', parent: 38, et: '3. Zugang' },
    { i: 196, t: 'gebrauchtwagen.de', group: 'gebrauchtwagen.de', parent: 38, et: '4. Zugang' },
    { i: 197, t: 'gebrauchtwagen.de', group: 'gebrauchtwagen.de', parent: 38, et: '5. Zugang' },
    { i: 198, t: 'gebrauchtwagen.de', group: 'gebrauchtwagen.de', parent: 38, et: '6. Zugang' },
    { i: 199, t: 'webauto.de', group: 'webmobile24', parent: 11, et: '3. Zugang' },
    { i: 200, t: 'webauto.de', group: 'webmobile24', parent: 11, et: '4. Zugang' },
    { i: 201, t: 'webauto.de', group: 'webmobile24', parent: 11, et: '5. Zugang' },
    { i: 202, t: 'webauto.de', group: 'webmobile24', parent: 11, et: '6. Zugang' },
    { i: 205, t: 'Homepage Mäke' },
    { i: 206, t: 'Homepage Wilsdruff' },
    { i: 209, t: 'Homepage Auto Kaden' },
    { i: 210, t: 'Homepage Autohaus Ebner' },
    { i: 211, t: 'camp24' },
    { i: 212, t: 'Classic Driver' },
    { i: 213, t: 'Mercedes Bilderserver' },
    { i: 214, t: 'GeWaTo', color: '#db002a', group: 'GeWaTo', parent: 8, et: '5. Zugang' },
    { i: 215, t: 'Homepage Autohaus Feicht' },
    { i: 216, t: 'automobile.de', group: 'automobile.de', parent: 34, et: '2. Zugang' },
    { i: 217, t: 'automobile.de', group: 'automobile.de', parent: 34, et: '3. Zugang' },
    { i: 218, t: 'Homepage Autohaus Poser' },
    { i: 219, t: 'MyAuto.lu' },
    { i: 220, t: 'joolonline.com' },
    { i: 223, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '7. Zugang' },
    { i: 224, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '8. Zugang' },
    { i: 225, t: 'mobile.de API', icon: MobileDeLogo, iconAutoSizeHeight: '1em', color: '#f60', group: 'mobile.de API', parent: 225, et: '1. Zugang' },
    { i: 226, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 226, et: '1. Zugang' },
    { i: 227, t: 'gebrauchtwagen.de', group: 'gebrauchtwagen.de', parent: 38, et: '7. Zugang' },
    { i: 228, t: 'gebrauchtwagen.de', group: 'gebrauchtwagen.de', parent: 38, et: '8. Zugang' },
    { i: 229, t: 'mobile.de API', icon: MobileDeLogo, iconAutoSizeHeight: '1em', color: '#f60', group: 'mobile.de API', parent: 225, et: '2. Zugang' },
    { i: 230, t: 'mobile.de API', icon: MobileDeLogo, iconAutoSizeHeight: '1em', color: '#f60', group: 'mobile.de API', parent: 225, et: '3. Zugang' },
    { i: 231, t: 'mobile.de API', icon: MobileDeLogo, iconAutoSizeHeight: '1em', color: '#f60', group: 'mobile.de API', parent: 225, et: '4. Zugang' },
    { i: 232, t: 'mobile.de API', icon: MobileDeLogo, iconAutoSizeHeight: '1em', color: '#f60', group: 'mobile.de API', parent: 225, et: '5. Zugang' },
    { i: 233, t: 'mobile.de API', icon: MobileDeLogo, iconAutoSizeHeight: '1em', color: '#f60', group: 'mobile.de API', parent: 225, et: '6. Zugang' },
    { i: 234, t: 'mobile.de API', icon: MobileDeLogo, iconAutoSizeHeight: '1em', color: '#f60', group: 'mobile.de API', parent: 225, et: '7. Zugang' },
    { i: 235, t: 'mobile.de API', icon: MobileDeLogo, iconAutoSizeHeight: '1em', color: '#f60', group: 'mobile.de API', parent: 225, et: '8. Zugang' },
    { i: 236, t: 'Carsb2B' },
    { i: 237, t: 'My-Motion STX3' },
    { i: 238, t: 'autohaus24.de' },
    { i: 239, t: 'leasingtime.de' },
    { i: 240, t: 'autoda.de' },
    { i: 241, t: 'Carneoo' },
    { i: 242, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '9. Zugang' },
    { i: 243, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '10. Zugang' },
    { i: 244, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '11. Zugang' },
    { i: 245, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '12. Zugang' },
    { i: 246, t: 'mobile.de API', icon: MobileDeLogo, iconAutoSizeHeight: '1em', color: '#f60', group: 'mobile.de API', parent: 225, et: '9. Zugang' },
    { i: 247, t: 'mobile.de API', icon: MobileDeLogo, iconAutoSizeHeight: '1em', color: '#f60', group: 'mobile.de API', parent: 225, et: '10. Zugang' },
    { i: 248, t: 'mobile.de API', icon: MobileDeLogo, iconAutoSizeHeight: '1em', color: '#f60', group: 'mobile.de API', parent: 225, et: '11. Zugang' },
    { i: 249, t: 'mobile.de API', icon: MobileDeLogo, iconAutoSizeHeight: '1em', color: '#f60', group: 'mobile.de API', parent: 225, et: '12. Zugang' },
    { i: 250, t: 'autohausen.de', group: 'autohausen.de', parent: 164, et: '2. Zugang' },
    { i: 251, t: 'mobile.de API', icon: MobileDeLogo, iconAutoSizeHeight: '1em', color: '#f60', group: 'mobile.de API', parent: 225, et: '13. Zugang' },
    { i: 252, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '13. Zugang' },
    { i: 253, t: 'Autosnip' },
    { i: 254, t: 'Citroen' },
    { i: 255, t: 'dotzilla Export' },
    { i: 256, t: 'Skoda Müller' },
    { i: 257, t: 'Skoda News' },
    { i: 258, t: 'dotzilla Export NW' },
    { i: 259, t: 'netconnection' },
    { i: 260, t: 'autobach' },
    { i: 261, t: 'skoda-auto.de', group: 'skoda-auto.de', parent: 87, et: '4. Zugang' },
    { i: 262, t: 'skoda-auto.de', group: 'skoda-auto.de', parent: 87, et: '5. Zugang' },
    { i: 263, t: 'Motoso', group: 'Motoso', parent: 102, et: '6. Zugang' },
    { i: 264, t: 'Motoso', group: 'Motoso', parent: 102, et: '7. Zugang' },
    { i: 265, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '14. Zugang' },
    { i: 266, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '15. Zugang' },
    { i: 267, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '16. Zugang' },
    { i: 268, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '17. Zugang' },
    { i: 269, hidden: true, t: 'autoscout24', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'autoscout24', parent: 2, et: '18. Zugang' },
    { i: 270, t: 'Mobile Test' },
    { i: 271, t: 'PlanetVO' },
    { i: 272, t: 'Flat 6' },
    { i: 273, t: 'Autando CSV' },
    { i: 274, t: 'webmobile24', group: 'webmobile24', parent: 4, et: '3. Zugang' },
    { i: 275, t: 'webmobile24', group: 'webmobile24', parent: 4, et: '4. Zugang' },
    { i: 276, t: 'webmobile24', group: 'webmobile24', parent: 4, et: '5. Zugang' },
    { i: 277, t: 'webmobile24', group: 'webmobile24', parent: 4, et: '6. Zugang' },
    { i: 278, t: 'webmobile24', group: 'webmobile24', parent: 4, et: '7. Zugang' },
    { i: 279, t: 'webmobile24', group: 'webmobile24', parent: 4, et: '8. Zugang' },
    { i: 280, t: 'webmobile24', group: 'webmobile24', parent: 4, et: '9. Zugang' },
    { i: 281, t: 'webmobile24', group: 'webmobile24', parent: 4, et: '10. Zugang' },
    { i: 282, t: 'webmobile24', group: 'webmobile24', parent: 4, et: '11. Zugang' },
    { i: 283, t: 'webmobile24', group: 'webmobile24', parent: 4, et: '12. Zugang' },
    { i: 284, t: 'dotzilla API' },
    { i: 285, t: 'Modix XML' },
    { i: 286, t: 'Carix' },
    { i: 287, t: 'automobile.de', group: 'automobile.de', parent: 34, et: '4. Zugang' },
    { i: 288, t: 'automobile.de', group: 'automobile.de', parent: 34, et: '5. Zugang' },
    { i: 289, t: 'AHD Cars', icon: AhdCarsLogo, iconAutoSizeHeight: '1em', color: '#137cbe' },
    { i: 290, t: 'automobile.de', group: 'automobile.de', parent: 34, et: '6. Zugang' },
    { i: 291, t: 'automobile.de', group: 'automobile.de', parent: 34, et: '7. Zugang' },
    { i: 292, t: 'Motoso', group: 'Motoso', parent: 102, et: '8. Zugang' },
    { i: 293, t: 'ELN' },
    { i: 294, t: 'autofokus' },
    { i: 295, t: 'FCM24' },
    { i: 296, t: 'haystack' },
    { i: 297, t: 'Aktionauto' },
    { i: 298, t: 'Attribut' },
    { i: 299, t: 'auto innovativ' },
    { i: 300, t: 'Homepage Schwarte Gruppe' },
    { i: 301, t: 'autocrm', group: 'autocrm', parent: 301, et: '1. Zugang' },
    { i: 302, t: 'autocrm', group: 'autocrm', parent: 301, et: '2. Zugang' },
    { i: 303, t: 'autocrm', group: 'autocrm', parent: 301, et: '3. Zugang' },
    { i: 304, t: 'autocrm', group: 'autocrm', parent: 301, et: '4. Zugang' },
    { i: 305, t: 'autocrm', group: 'autocrm', parent: 301, et: '5. Zugang' },
    { i: 306, t: 'Verivox' },
    { i: 307, t: 'HeyCar', icon: HeyCarLogo, iconAutoSizeHeight: '1em', color: '#00cea4', group: 'HeyCar', parent: 307, et: '1. Zugang' },
    { i: 308, t: 'GeWaTo', color: '#db002a', group: 'GeWaTo', parent: 8, et: '6. Zugang' },
    { i: 309, t: 'GeWaTo', color: '#db002a', group: 'GeWaTo', parent: 8, et: '7. Zugang' },
    { i: 310, t: 'autocrm', group: 'autocrm', parent: 301, et: '6. Zugang' },
    { i: 311, t: 'autocrm', group: 'autocrm', parent: 301, et: '7. Zugang' },
    { i: 312, t: 'Carlution' },
    { i: 313, t: 'autocrm', group: 'autocrm', parent: 301, et: '8. Zugang' },
    { i: 314, t: 'autocrm', group: 'autocrm', parent: 301, et: '9. Zugang' },
    { i: 315, t: 'Modix', group: 'Modix', parent: 102, et: '2. Zugang' },
    { i: 316, t: 'Modix', group: 'Modix', parent: 102, et: '3. Zugang' },
    { i: 317, t: 'Modix', group: 'Modix', parent: 102, et: '4. Zugang' },
    { i: 318, t: 'Modix', group: 'Modix', parent: 102, et: '5. Zugang' },
    { i: 319, t: 'Modix', group: 'Modix', parent: 102, et: '6. Zugang' },
    { i: 320, t: 'Modix', group: 'Modix', parent: 102, et: '7. Zugang' },
    { i: 321, t: 'Modix', group: 'Modix', parent: 102, et: '8. Zugang' },
    { i: 322, t: 'Modix', group: 'Modix', parent: 102, et: '9. Zugang' },
    { i: 323, t: 'PKW.DE', group: 'PKW.DE', parent: 121, et: '2. Zugang' },
    { i: 324, t: 'HeyCar', icon: HeyCarLogo, iconAutoSizeHeight: '1em', color: '#00cea4', group: 'HeyCar', parent: 307, et: '2. Zugang' },
    { i: 325, t: 'HeyCar', icon: HeyCarLogo, iconAutoSizeHeight: '1em', color: '#00cea4', group: 'HeyCar', parent: 307, et: '3. Zugang' },
    { i: 326, t: 'HeyCar', icon: HeyCarLogo, iconAutoSizeHeight: '1em', color: '#00cea4', group: 'HeyCar', parent: 307, et: '4. Zugang' },
    { i: 327, t: 'HeyCar', icon: HeyCarLogo, iconAutoSizeHeight: '1em', color: '#00cea4', group: 'HeyCar', parent: 307, et: '5. Zugang' },
    { i: 328, t: 'HeyCar', icon: HeyCarLogo, iconAutoSizeHeight: '1em', color: '#00cea4', group: 'HeyCar', parent: 307, et: '6. Zugang' },
    { i: 329, t: 'HeyCar', icon: HeyCarLogo, iconAutoSizeHeight: '1em', color: '#00cea4', group: 'HeyCar', parent: 307, et: '7. Zugang' },
    { i: 330, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '2. Zugang' },
    { i: 331, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '3. Zugang' },
    { i: 332, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '4. Zugang' },
    { i: 333, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '5. Zugang' },
    { i: 334, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '6. Zugang' },
    { i: 335, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '7. Zugang' },
    { i: 336, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '8. Zugang' },
    { i: 337, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '9. Zugang' },
    { i: 338, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '10. Zugang' },
    { i: 339, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '11. Zugang' },
    { i: 340, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '12. Zugang' },
    { i: 341, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '13. Zugang' },
    { i: 342, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '14. Zugang' },
    { i: 343, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '15. Zugang' },
    { i: 344, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '16. Zugang' },
    { i: 345, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '17. Zugang' },
    { i: 346, t: 'as24.de API', icon: Autoscout24Logo, iconAutoSizeHeight: '1em', color: '#003468', group: 'as24.de API', parent: 225, et: '18. Zugang' },
    { i: 347, t: 'CarGurus', icon: CarGurusLogo, iconAutoSizeHeight: '1em', group: 'CarGurus', parent: 347, et: '1. Zugang' },
    { i: 348, t: 'WVD Marketing' },
    { i: 350, t: 'noblecars' },
    { i: 351, t: 'CarGurus', icon: CarGurusLogo, iconAutoSizeHeight: '1em', group: 'CarGurus', parent: 347, et: '2. Zugang' },
    { i: 352, t: 'CarGurus', icon: CarGurusLogo, iconAutoSizeHeight: '1em', group: 'CarGurus', parent: 347, et: '3. Zugang' },
    { i: 353, t: 'CarGurus', icon: CarGurusLogo, iconAutoSizeHeight: '1em', group: 'CarGurus', parent: 347, et: '4. Zugang' },
    { i: 354, t: 'CarGurus', icon: CarGurusLogo, iconAutoSizeHeight: '1em', group: 'CarGurus', parent: 347, et: '5. Zugang' },
    { i: 355, t: 'CarGurus', icon: CarGurusLogo, iconAutoSizeHeight: '1em', group: 'CarGurus', parent: 347, et: '6. Zugang' },
    { i: 356, t: 'CarGurus', icon: CarGurusLogo, iconAutoSizeHeight: '1em', group: 'CarGurus', parent: 347, et: '7. Zugang' },
    { i: 357, t: 'CarGurus', icon: CarGurusLogo, iconAutoSizeHeight: '1em', group: 'CarGurus', parent: 347, et: '8. Zugang' },
    { i: 358, t: 'CarGurus', icon: CarGurusLogo, iconAutoSizeHeight: '1em', group: 'CarGurus', parent: 347, et: '9. Zugang' },
    { i: 359, t: 'CarGurus', icon: CarGurusLogo, iconAutoSizeHeight: '1em', group: 'CarGurus', parent: 347, et: '10. Zugang' },
    { i: 360, t: 'CarGurus', icon: CarGurusLogo, iconAutoSizeHeight: '1em', group: 'CarGurus', parent: 347, et: '11. Zugang' },
    { i: 361, t: 'CarGurus', icon: CarGurusLogo, iconAutoSizeHeight: '1em', group: 'CarGurus', parent: 347, et: '12. Zugang' },
    { i: 362, t: 'gebrauchtwagen.de', group: 'gebrauchtwagen.de', parent: 38, et: '9. Zugang' },
    { i: 363, t: 'gebrauchtwagen.de', group: 'gebrauchtwagen.de', parent: 38, et: '10. Zugang' },
    { i: 364, t: 'gebrauchtwagen.de', group: 'gebrauchtwagen.de', parent: 38, et: '11. Zugang' },
    { i: 365, t: 'gebrauchtwagen.de', group: 'gebrauchtwagen.de', parent: 38, et: '12. Zugang' },
    { i: 366, t: 'mediatack' },
    { i: 367, t: 'instamotion' },
    { i: 368, t: 'mobilapp.io' },
    { i: 369, t: 'neuwagen24.de' },
    { i: 370, t: 'AUTOACTIVA' },
    { i: 371, t: 'Trucks NL' },
    { i: 372, t: 'HeyCar', icon: HeyCarLogo, iconAutoSizeHeight: '1em', color: '#00cea4', group: 'HeyCar', parent: 307, et: '8. Zugang' },
    { i: 373, t: 'HeyCar', icon: HeyCarLogo, iconAutoSizeHeight: '1em', color: '#00cea4', group: 'HeyCar', parent: 307, et: '9. Zugang' },
    { i: 374, t: 'HeyCar', icon: HeyCarLogo, iconAutoSizeHeight: '1em', color: '#00cea4', group: 'HeyCar', parent: 307, et: '10. Zugang' },
    { i: 375, t: 'HeyCar', icon: HeyCarLogo, iconAutoSizeHeight: '1em', color: '#00cea4', group: 'HeyCar', parent: 307, et: '11. Zugang' },
    { i: 376, t: 'HeyCar', icon: HeyCarLogo, iconAutoSizeHeight: '1em', color: '#00cea4', group: 'HeyCar', parent: 307, et: '12. Zugang' },
    { i: 377, t: 'KOSY' },
    { i: 378, t: 'LeasingMarkt', icon: LeasingMarktLogo, iconAutoSizeHeight: '1em', group: 'LeasingMarkt', parent: 378, et: '1. Zugang' },
    { i: 379, t: 'MotorK', group: 'MotorK', parent: 379, et: '1. Zugang' },
    { i: 380, t: 'LeasingMarkt', icon: LeasingMarktLogo, iconAutoSizeHeight: '1em', group: 'LeasingMarkt', parent: 378, et: '2. Zugang' },
    { i: 381, t: 'LeasingMarkt', icon: LeasingMarktLogo, iconAutoSizeHeight: '1em', group: 'LeasingMarkt', parent: 378, et: '3. Zugang' },
    { i: 382, t: 'LeasingMarkt', icon: LeasingMarktLogo, iconAutoSizeHeight: '1em', group: 'LeasingMarkt', parent: 378, et: '4. Zugang' },
    { i: 383, t: 'carwow', group: 'carwow', parent: 383, et: '1. Zugang' },
    { i: 384, t: 'audaris' },
    { i: 385, t: 'deineautoboerse' },
    { i: 386, t: 'carwow', group: 'carwow', parent: 383, et: '2. Zugang' },
    { i: 387, t: 'carwow', group: 'carwow', parent: 383, et: '3. Zugang' },
    { i: 388, t: 'carwow', group: 'carwow', parent: 383, et: '4. Zugang' },
    { i: 389, t: 'carwow', group: 'carwow', parent: 383, et: '5. Zugang' },
    { i: 390, t: 'Carmacs' },
    { i: 393, t: 'MotorK', group: 'MotorK', parent: 379, et: '2. Zugang' },
    { i: 394, t: 'MotorK', group: 'MotorK', parent: 379, et: '3. Zugang' },
    { i: 395, t: 'MotorK', group: 'MotorK', parent: 379, et: '4. Zugang' },
    { i: 396, t: 'MotorK', group: 'MotorK', parent: 379, et: '5. Zugang' },
    { i: 397, t: 'MotorK', group: 'MotorK', parent: 379, et: '6. Zugang' },
    { i: 398, t: 'MotorK', group: 'MotorK', parent: 379, et: '7. Zugang' },
    { i: 399, t: 'MotorK', group: 'MotorK', parent: 379, et: '8. Zugang' },
    { i: 400, t: 'MotorK', group: 'MotorK', parent: 379, et: '9. Zugang' },
    { i: 401, t: 'MotorK', group: 'MotorK', parent: 379, et: '10. Zugang' },
    { i: 402, t: 'MotorK', group: 'MotorK', parent: 379, et: '11. Zugang' },
    { i: 403, t: 'MotorK', group: 'MotorK', parent: 379, et: '12. Zugang' },
    { i: 404, t: 'Claris Berolina' },
    { i: 405, t: 'Null Leasing' },
    { i: 406, t: 'dickekreativ' },
    { i: 407, t: 'carbando' },
    { i: 408, t: 'Deltakonzept', group: 'Deltakonzept', parent: 94, et: '2. Zugang' },
    { i: 409, t: 'Deltakonzept', group: 'Deltakonzept', parent: 94, et: '3. Zugang' },
    { i: 410, t: 'Deltakonzept', group: 'Deltakonzept', parent: 94, et: '4. Zugang' },
    { i: 411, t: 'Deltakonzept', group: 'Deltakonzept', parent: 94, et: '5. Zugang' },
    { i: 412, t: 'EVA DB Export' },
    { i: 413, t: 'Cluno' },
    { i: 414, t: '1on1', icon: Web1On1Logo, iconAutoSizeHeight: '1em' },
    { i: 415, t: 'Auto1' },
    { i: 416, t: 'BDK - Partner' },
    { i: 417, t: 'AutoUncle', icon: AutoUncleLogo, iconAutoSizeHeight: '1em' },
    { i: 418, t: 'CD-Systeme', group: 'cdsysteme', parent: 418 },
    { i: 419, t: 'juhu.AUTO', group: 'juhuauto', parent: 419, et: '1. Zugang' },
    { i: 420, t: 'LeasingMarkt', icon: LeasingMarktLogo, iconAutoSizeHeight: '1em', group: 'LeasingMarkt', parent: 378, et: '5. Zugang' },
    { i: 421, t: 'LeasingMarkt', icon: LeasingMarktLogo, iconAutoSizeHeight: '1em', group: 'LeasingMarkt', parent: 378, et: '6. Zugang' },
    { i: 422, t: 'LeasingMarkt', icon: LeasingMarktLogo, iconAutoSizeHeight: '1em', group: 'LeasingMarkt', parent: 378, et: '7. Zugang' },
    { i: 423, t: 'AHD Scan (ehem. CARQR)', icon: AhdScanLogo, iconAutoSizeHeight: '1em' },
    { i: 424, t: 'Yes.Auto' },
    { i: 425, t: 'dealerdesk' },
    { i: 426, t: 'Auto-Kölbl-HP' },
    { i: 427, t: 'Dicoso' },
    { i: 428, t: 'EPS' },
    { i: 429, t: 'LeasingMarkt', icon: LeasingMarktLogo, iconAutoSizeHeight: '1em', group: 'LeasingMarkt', parent: 378, et: '8. Zugang' },
    { i: 430, t: 'LeasingMarkt', icon: LeasingMarktLogo, iconAutoSizeHeight: '1em', group: 'LeasingMarkt', parent: 378, et: '9. Zugang' },
    { i: 431, t: 'LeasingMarkt', icon: LeasingMarktLogo, iconAutoSizeHeight: '1em', group: 'LeasingMarkt', parent: 378, et: '10. Zugang' },
    { i: 432, t: 'WS-Informatik' },
    { i: 433, t: 'Smive', group: 'Smive', parent: 433, et: '1. Zugang' },
    { i: 434, t: 'BMW Bilderserver' },
    { i: 435, t: 'VW Financial Services', icon: VWFinancialServices, iconAutoSizeHeight: '1em' },
    { i: 436, t: 'eAutoseller' },
    { i: 437, t: 'MotorK Bilder' },
    { i: 438, t: 'Smive', group: 'Smive', parent: 433, et: '2. Zugang' },
    { i: 439, t: 'Faaren' },
    { i: 440, t: 'guteRate' },
    { i: 441, t: 'Santander Bank', warningSPT: 'Kein Export zu diesem Portal (Reines Lead-Portal)' },
    { i: 442, t: 'Carmato' },
    { i: 443, t: 'Kammergruber' },
    { i: 444, t: 'KUNIN' },
    { i: 445, t: 'E-AUTOS.de' },
    { i: 446, t: 'ViveLaCar' },
    { i: 447, t: 'GEDAK' },
    { i: 448, t: 'digit.ly' },
    { i: 449, t: 'Claris-Bild' },
    { i: 450, t: 'sdox SE', group: 'sdox SE', parent: 450, et: '1. Zugang' },
    { i: 451, t: 'mytec', group: 'mytec', parent: 451, et: '1. Zugang' },
    { i: 452, t: 'mytec', group: 'mytec', parent: 451, et: '2. Zugang' },
    { i: 453, t: 'prof4net' },
    { i: 454, t: 'dasAboMobil' },
    { i: 455, t: 'Mobility Ads' },
    { i: 456, t: 'VisiOne' },
    { i: 457, t: 'AH-Zehder-HP' },
    { i: 458, t: 'DAAG' },
    { i: 459, t: 'cardess' },
    { i: 460, t: 'ARS' },
    { i: 461, t: 'carwow6' },
    { i: 462, t: 'webclan' },
    { i: 464, t: 'sdox SE', group: 'sdox SE', parent: 450, et: '2. Zugang' },
    // { i: 465, t: 'NICHT VERGEBEN' },
    { i: 466, t: 'Lizy' },
    { i: 467, t: 'locarl', icon: LocarlLogo, iconAutoSizeHeight: '1em' },
    { i: 468, t: 'ALLES.AUTO', icon: AllesAutoLogo, iconAutoSizeHeight: '1em' },
    { i: 469, t: 'digital35', group: 'digital35', parent: 469, et: '1. Zugang', icon: Digital35Logo, iconAutoSizeHeight: '1em' },
    { i: 470, t: 'AUTOproff' },
    { i: 471, t: 'ITKrebs' },
    { i: 472, t: 'CX9', icon: CX9Logo, iconAutoSizeHeight: '1em' },
    { i: 473, t: 'Preistool' },
    { i: 474, t: 'AutoAbo' },
    { i: 475, t: 'auto-flat' },
    { i: 476, t: 'webkommunikation24', icon: Webkommunikation24Logo, iconAutoSizeHeight: '1em' },
    { i: 477, t: 'EVIUM', icon: EviumLogo, iconAutoSizeHeight: '1em' },
    { i: 478, t: 'autobörse.de by Santander', group: 'autobörse.de by Santander', icon: SantanderLogo, parent: 478, et: '1. Zugang' },
    { i: 479, t: 'autobörse.de by Santander', group: 'autobörse.de by Santander', icon: SantanderLogo, parent: 478, et: '2. Zugang' },
    { i: 480, t: 'autobörse.de by Santander', group: 'autobörse.de by Santander', icon: SantanderLogo, parent: 478, et: '3. Zugang' },
    { i: 481, t: 'autobörse.de by Santander', group: 'autobörse.de by Santander', icon: SantanderLogo, parent: 478, et: '4. Zugang' },
    { i: 482, t: 'autobörse.de by Santander', group: 'autobörse.de by Santander', icon: SantanderLogo, parent: 478, et: '5. Zugang' },
    { i: 483, t: 'autobörse.de by Santander', group: 'autobörse.de by Santander', icon: SantanderLogo, parent: 478, et: '6. Zugang' },
    { i: 484, t: 'digital35', group: 'digital35', parent: 469, et: '2. Zugang', icon: Digital35Logo, iconAutoSizeHeight: '1em' },
    { i: 485, t: 'Google VLA', hidden: true },
    { i: 486, t: 'autobörse.de by Santander', group: 'autobörse.de by Santander', icon: SantanderLogo, parent: 478, et: '7. Zugang' },
    { i: 487, t: 'juhu.AUTO', group: 'juhuauto', parent: 419, et: '2. Zugang' },
];
export default sPortalId;
